export default "/public/dist/img/Cosefoto_3.jpg";